import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-883bde5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "widget__card" }
const _hoisted_2 = { class: "widget__content" }
const _hoisted_3 = { class: "widget__left custom__widget" }
const _hoisted_4 = { class: "widget_inner__content" }
const _hoisted_5 = { class: "widget__count" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "iknowa", -1))
const _hoisted_7 = { class: "ratio" }
const _hoisted_8 = { class: "widget__right custom__widget" }
const _hoisted_9 = { class: "widget_inner__content" }
const _hoisted_10 = { class: "widget__count" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Direct", -1))
const _hoisted_12 = { class: "ratio" }
const _hoisted_13 = { class: "widget__content" }
const _hoisted_14 = { class: "widget__left custom__widget" }
const _hoisted_15 = { class: "widget_inner__content" }
const _hoisted_16 = { class: "widget__count" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "iknowa", -1))
const _hoisted_18 = { class: "ratio" }
const _hoisted_19 = { class: "widget__right custom__widget" }
const _hoisted_20 = { class: "widget_inner__content" }
const _hoisted_21 = { class: "widget__count" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Direct", -1))
const _hoisted_23 = { class: "ratio" }
const _hoisted_24 = { class: "widget__content" }
const _hoisted_25 = {
  key: 0,
  class: "rating__content"
}
const _hoisted_26 = { class: "customer__info" }
const _hoisted_27 = { class: "customer__icon" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "view-rating-box" }
const _hoisted_30 = {
  key: 1,
  class: "tw-w-full tw-h-full tw-flex tw-flex-col tw-gap-2 tw-items-center tw-justify-center"
}
const _hoisted_31 = { class: "tw-flex tw-items-center tw-gap-[.1rem]" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import UserProfileLogo from "@/core/components/UserProfileLogo.vue";
import AnalyticsWidgetLayout from "@/core/components/slots/AnalyticsWidgetLayout.vue";
import { ANALYTICS_STORE } from "@/store/modules/analytics";
import { USER_STORE } from "@/store/modules/user";
import { WORKSTATION } from "@/store/modules/workstation";
import { computed } from "vue";
import { useStore } from "vuex";
import { reviewRatingState } from "@/core/models/project-rating";
import { REVIEW_RATING_STORE } from "@/store/modules/review-rating";
import { getCombineSameProjectReview } from "@/core/utils/common";
import Text from "@/core/components/ui/general/Text.vue";
import EmptyStarIcon from "@/core/components/icons/EmptyStarIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EstimatesJobsRatingCardsLayout',
  setup(__props) {

const store = useStore();

const estimatesSent = computed(
  () => store.getters[`${ANALYTICS_STORE}/getEstimatesSent`]
);

const jobsCompleted = computed(
  () => store.getters[`${ANALYTICS_STORE}/getJobsCompleted`]
);
const customerRating = computed(
  () => store.getters[`${ANALYTICS_STORE}/getCustomerRating`]
);
const userWorkStationImage = computed(() => {
  return store.getters[`${USER_STORE}/userWorkStationImage`];
});

const activeUserWorkstation = computed(() => {
  return store.getters[`${WORKSTATION}/activeUserWorkstation`];
});

const getAllProjectReviewList = computed<
  reviewRatingState["allProjectReviewList"]
>(() => store.getters[`${REVIEW_RATING_STORE}/getAllProjectReviewList`]);

const combineSameProjectReview = computed(() =>
  getCombineSameProjectReview(getAllProjectReviewList.value)
);
const getAverageOfAllProjectReview = computed(() => {
  const totalAvg = combineSameProjectReview.value.reduce(
    (totalRating: number, review: any) => {
      totalRating += review.totalAvg || 0;
      return totalRating;
    },
    0
  );
  return totalAvg
    ? Math.round((totalAvg * 100) / combineSameProjectReview.value.length) / 100
    : totalAvg;
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_rating = _resolveComponent("v-rating")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AnalyticsWidgetLayout, {
      class: "estimate__card",
      title: "Estimates Sent",
      hideToolTip: true,
      headerIcon: "analyticsEstimateSent"
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h3", null, _toDisplayString(estimatesSent.value?.iknowaCount), 1),
                _hoisted_6
              ]),
              _createElementVNode("div", _hoisted_7, [
                (estimatesSent.value?.iknowaPercentage)
                  ? (_openBlock(), _createBlock(_component_v_icon, {
                      key: 0,
                      icon: "mdi-arrow-top-right",
                      class: "up-arrow"
                    }))
                  : _createCommentVNode("", true),
                (estimatesSent.value?.iknowaPercentage < 0)
                  ? (_openBlock(), _createBlock(_component_v_icon, {
                      key: 1,
                      icon: "mdi-arrow-bottom-right",
                      class: "down-arrow"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("span", null, _toDisplayString(estimatesSent.value?.iknowaPercentage ? "+" : "") + _toDisplayString(estimatesSent.value?.iknowaPercentage) + "%", 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("h3", null, _toDisplayString(estimatesSent.value?.directCount), 1),
                _hoisted_11
              ]),
              _createElementVNode("div", _hoisted_12, [
                (estimatesSent.value?.directPercentage)
                  ? (_openBlock(), _createBlock(_component_v_icon, {
                      key: 0,
                      icon: "mdi-arrow-top-right",
                      class: "up-arrow"
                    }))
                  : _createCommentVNode("", true),
                (estimatesSent.value?.directPercentage < 0)
                  ? (_openBlock(), _createBlock(_component_v_icon, {
                      key: 1,
                      icon: "mdi-arrow-bottom-right",
                      class: "down-arrow"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("span", null, _toDisplayString(estimatesSent.value?.directPercentage ? "+" : "") + _toDisplayString(estimatesSent.value?.directPercentage) + "%", 1)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(AnalyticsWidgetLayout, {
      class: "jobs__card",
      title: "Jobs Completed",
      hideToolTip: true,
      headerIcon: "analyticsJobsCompleted"
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("h3", null, _toDisplayString(jobsCompleted.value?.iknowaCount), 1),
                _hoisted_17
              ]),
              _createElementVNode("div", _hoisted_18, [
                (jobsCompleted.value?.iknowaPercentage)
                  ? (_openBlock(), _createBlock(_component_v_icon, {
                      key: 0,
                      icon: "mdi-arrow-top-right",
                      class: "up-arrow"
                    }))
                  : _createCommentVNode("", true),
                (jobsCompleted.value?.iknowaPercentage < 0)
                  ? (_openBlock(), _createBlock(_component_v_icon, {
                      key: 1,
                      icon: "mdi-arrow-bottom-right",
                      class: "down-arrow"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("span", null, _toDisplayString(jobsCompleted.value?.iknowaPercentage ? "+" : "") + _toDisplayString(jobsCompleted.value?.iknowaPercentage) + "%", 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("h3", null, _toDisplayString(jobsCompleted.value?.directCount), 1),
                _hoisted_22
              ]),
              _createElementVNode("div", _hoisted_23, [
                (jobsCompleted.value?.directPercentage)
                  ? (_openBlock(), _createBlock(_component_v_icon, {
                      key: 0,
                      icon: "mdi-arrow-top-right",
                      class: "up-arrow"
                    }))
                  : _createCommentVNode("", true),
                (jobsCompleted.value?.directPercentage < 0)
                  ? (_openBlock(), _createBlock(_component_v_icon, {
                      key: 1,
                      icon: "mdi-arrow-bottom-right",
                      class: "down-arrow"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("span", null, _toDisplayString(jobsCompleted.value?.directPercentage ? "+" : "") + _toDisplayString(jobsCompleted.value?.directPercentage) + "%", 1)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(AnalyticsWidgetLayout, {
      class: "rating__card",
      title: "Customer Rating",
      hideToolTip: true,
      headerIcon: "analyticsCustomerRating"
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_24, [
          (getAverageOfAllProjectReview.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    (userWorkStationImage.value)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: userWorkStationImage.value,
                          alt: ""
                        }, null, 8, _hoisted_28))
                      : (_openBlock(), _createBlock(UserProfileLogo, {
                          key: 1,
                          isRounded: false,
                          userName: activeUserWorkstation.value?.name,
                          class: "!tw-rounded-full"
                        }, null, 8, ["userName"]))
                  ]),
                  _createElementVNode("p", null, _toDisplayString(activeUserWorkstation.value?.name), 1)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_v_rating, {
                    "model-value": getAverageOfAllProjectReview.value,
                    "active-color": "orange",
                    color: "rgba(12, 15, 74, 0.26)",
                    "empty-icon": "mdi-star",
                    readonly: ""
                  }, null, 8, ["model-value"]),
                  _createElementVNode("p", null, _toDisplayString(getAverageOfAllProjectReview.value) + " out of 5", 1)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createVNode(Text, {
                  class: "!tw-text-[30px]",
                  textWeight: "600"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("0.0")
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_31, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (item) => {
                    return _createVNode(EmptyStarIcon, { key: item })
                  }), 64))
                ]),
                _createVNode(Text, {
                  textWeight: "500",
                  variant: "p",
                  textColor: "rgba(12, 15, 74, 0.5)",
                  lineHeight: "18px"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("You don’t have any reviews yet."),
                    _hoisted_32,
                    _createTextVNode(" Complete jobs to receive reviews.")
                  ]),
                  _: 1
                })
              ]))
        ])
      ]),
      _: 1
    })
  ]))
}
}

})